import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { messageTypeLabels } from '../hooks/useSentMessagesScreen';

export default function SentMessageDialog({ message, onClose, onOpenReference, fullScreen }) {
  const hasReference = message?.type === 'APPOINTMENT_REMINDER' && Boolean(message?.referenceId);

  return (
    <Dialog
      open={Boolean(message)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle>Mensagem enviada</DialogTitle>
      {message && (
        <DialogContent dividers>
          <Stack spacing={1.5}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
              <Chip
                label={messageTypeLabels[message.type] ?? message.type}
                size="small"
                color="success"
                variant="outlined"
              />
              <Typography variant="body2" color="text.secondary">
                Enviada em {message.sentAt}
              </Typography>
            </Stack>
            <Typography variant="body2">
              <strong>Destinatário:</strong> {message.recipientName || '—'}
            </Typography>
            <Typography variant="body2">
              <strong>Telefone:</strong> {message.recipientPhone || '—'}
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: 'pre-wrap', bgcolor: 'action.hover', borderRadius: 2, p: 1.5 }}
            >
              {message.content}
            </Typography>
          </Stack>
        </DialogContent>
      )}
      <DialogActions>
        {hasReference && <Button onClick={() => onOpenReference(message)}>Ver consulta</Button>}
        <Button variant="contained" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SentMessageDialog.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string,
    referenceId: PropTypes.number,
    recipientName: PropTypes.string,
    recipientPhone: PropTypes.string,
    content: PropTypes.string,
    sentAt: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onOpenReference: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool,
};

SentMessageDialog.defaultProps = {
  message: null,
  fullScreen: false,
};
